import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaInstagram, FaYoutube, FaGithub } from 'react-icons/fa';
import { FaXTwitter } from 'react-icons/fa6';
import { HiOutlineMail } from 'react-icons/hi';
import './Footer.css';

import { useDispatch, useSelector } from 'react-redux';
import { getAdminInfo } from '../features/adminInfo/adminInfoSlice';

const Footer = () => {
  const dispatch = useDispatch();
  // DÜZELTME: Doğru state'i seçiyoruz -> state.adminInfo
  const { info } = useSelector((state) => state.adminInfo);

  useEffect(() => {
    // Bileşen yüklendiğinde bilgileri çek
    if (!info) {
      dispatch(getAdminInfo());
    }
  }, [dispatch, info]);

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-grid">
          <div className="footer-about">
            <h3 className="footer-logo">{info?.fullName || 'SSI Association'}</h3>
            <p>Empowering youth through sustainable innovation and international collaboration.</p>
          </div>
          <div className="footer-links">
            <h4>Quick Access</h4>
            <ul>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/services">Projects</Link></li>
              <li><Link to="/blogs">Blog</Link></li>
              <li><Link to="/contact">Contact</Link></li>
              <li><Link to="/cookie-policy">Cookie Policy</Link></li>
              <li><Link to="https://drive.google.com/drive/folders/1mTQcwV2uaELJsYLX4Q3S-42s5DNEOt8E">PIF & Documents</Link></li>
            </ul>
          </div>
          {/* DİNAMİK: İletişim Bilgileri Bölümü */}
          <div className="footer-contact">
            <h4>Communication</h4>
            {info?.address && <p>{info.address}</p>}
            {info?.email && <p>{info.email}</p>}
            {info?.phone && <p>{info.phone}</p>}
          </div>
        </div>
        {/* DİNAMİK: Sosyal Medya İkonları Bölümü */}
        <div className="footer-social">
          {/* Instagram */}
          {info?.instagramUrl && (
            <a href={info.instagramUrl} target="_blank" rel="noopener noreferrer" className="social-icon">
              <FaInstagram />
            </a>
          )}
          
          {/* Facebook (Veritabanında olmadığı için şimdilik gösterilmiyor) */}
          
          {/* X (Twitter) */}
          {info?.xUrl && (
            <a href={info.xUrl} target="_blank" rel="noopener noreferrer" className="social-icon">
              <FaXTwitter />
            </a>
          )}

          {/* YouTube */}
          {info?.youtubeUrl && (
            <a href={info.youtubeUrl} target="_blank" rel="noopener noreferrer" className="social-icon">
              <FaYoutube />
            </a>
          )}

          {/* E-posta */}
          {info?.email && (
            <a href={`mailto:${info.email}`} className="social-icon">
              <HiOutlineMail />
            </a>
          )}
        </div>
        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} SSI IT TEAM. <a target="_blank" rel="noopener noreferrer" className="social-icon" href="https://github.com/gelisgen03"> <FaGithub /> </a> All rights reserved. </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;